var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"9","viewBox":"0 0 14 9","fill":"none"}},[_c('path',{attrs:{"d":"M1.645 0L7 5.34333L12.355 0L14 1.645L7 8.645L0 1.645L1.645 0Z","fill":"#5E6A79"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }